import { useState } from 'react'
import { AccountRecord, useUpdateAccountMutation } from '../../api/client'
import { AutoAction, getAutoActions } from './autoActions'
import DescriptiveToggle from './DescriptiveToggle'

const AutoDeleteSevereContentToggle = ({ account }: { account: AccountRecord }) => {
    const [updateAccountMutation, { loading }] = useUpdateAccountMutation()
    const [enabled, setEnabled] = useState(account.autoDeleteSevereContent)

    const onToggle = async (isEnabled: boolean) => {
        setEnabled(isEnabled)
        await updateAccountMutation({
            variables: {
                id: Number(account.id),
                autoDeleteSevereContent: !enabled
            }
        })
    }
    const disabled =
        getAutoActions(account.socialMediaServiceDisplayName || '').includes(AutoAction.Delete) ===
        false

    return (
        <DescriptiveToggle
            id="AutoDeleteSevere"
            disabled={disabled}
            checked={enabled}
            onToggle={onToggle}
            label="Auto-delete"
            loading={loading}
            subtitle="Permanently deletes the comment. On some platforms the commenter is notified. Cannot be reversed."
            tooltip={disabled ? `Not supported by this social network` : ``}
        />
    )
}

export default AutoDeleteSevereContentToggle
